interface IAttentionIconProps {
  color?: string;
  className?: string;
}

const NotificationIcon: React.FC<IAttentionIconProps> = ({
  color,
  className,
}) => (
  <svg
    width="61"
    height="61"
    viewBox="0 0 61 61"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M37.75 8 50.3 40.63l5.02 2.51v7.53H5.12v-7.53l5.02-2.51L22.69 8h15.06zm-2.51 5.02h-5.02v30.12h15.06L35.24 13.02z"
        style={{ fill: `${color || 'var(--tt-dark-purple)'}` }}
      />
      <path
        style={{ fill: `${color || 'var(--tt-yellow)'}` }}
        d="M22.69.47h15.06v2.51H22.69zM25.2 55.69h10.04v5.02H25.2z"
      />
    </g>
  </svg>
);

export default NotificationIcon;
